import { Component, Input } from '@angular/core';
import { ITimelineEntry } from '@app/directives/_veri/v-timeline/v-timeline.component';
import { IGoogleMapsMarker } from '@app/interfaces/IGoogleMapsMarkerOptions';
import { VideoEventCode } from '@app/main/components/videos/enums/VideoEventCode';
import { VideoStatus } from '@app/main/components/videos/enums/VideoStatus';
import { IVideoChannelMedia } from '@app/main/components/videos/models/IVideoChannelMedia';
import { IVideoEntry } from '@app/main/components/videos/models/IVideoEntry';
import { FoundationVideoService } from '@app/main/modules/foundation/_services/video.service';
import { MapService } from '@app/services/map.service';
import { TranslationService } from '@app/services/translation.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { mergeMap } from 'rxjs/operators';
import './camera-video-view.component.scss';

@Component({
    selector: 'camera-video-view',
    template: require('./camera-video-view.component.html')
})
export class CameraVideoViewComponent {
    @Input() videoId: number;
    video: IVideoEntry;

    mapMarker: IGoogleMapsMarker;
    timelineEntries: ITimelineEntry[];

    loading: boolean;

    VideoEventCode = VideoEventCode;
    VideoStatus = VideoStatus;
    constructor(
        private readonly mapService: MapService,
        private readonly translationService: TranslationService,
        private readonly videoService: FoundationVideoService) { }

    ngOnInit(): void {
        this.getVideo();
    }

    //--

    private getVideo(): void {
        if (!this.videoId) {
            return;
        }

        this.videoService.getVideoEntries({ Id: this.videoId }).pipe(
            untilDestroyed(this),
            mergeMap(videos => {
                this.video = videos[0];
                return this.videoService.getChannelMedia({ VideoEventId: this.video.Id });
            })
        ).subscribe({
            next: channelMedia => {
                this.setChannelMedia(channelMedia);
                this.createMapMarker();
                this.createTimelineFromAuditTrail();
            },
            complete: this.cancelLoading,
            error: this.cancelLoading
        })
    }

    private cancelLoading(): void {
        this.loading = false;
    }

    private setChannelMedia(channelMedia: IVideoChannelMedia[]): void {
        channelMedia.forEach(cm => {
            if (cm.ChannelId > 0) {
                this.video.channelMedia.push(cm);
            }
        })
    }

    private createMapMarker(): void {
        this.mapMarker = this.mapService.createMapMarker({ Latitude: this.video.Latitude, Longitude: this.video.Longitude }, { showLabel: true, label: this.translationService.t("Common.Location") })
    }

    private createTimelineFromAuditTrail(): void {
        if (!this.video.MetaData?.AuditLogs) {
            return;
        }

        this.timelineEntries = [];

        this.video.MetaData.AuditLogs.forEach(log => {
            const splitLog = log.split(":");
            const logDate = splitLog.slice(0, 3).join(":");
            const logText = splitLog[3];

            this.timelineEntries.push({
                date: new Date(logDate),
                icon: 'schedule',
                largeDetails: {
                    title: logText
                }
            })
        })
    }
}
